import { Fab, Tooltip } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const WhatsAppFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: '104px',
  right: '40px',
  zIndex: 1000,
  backgroundColor: '#25D366',
  color: '#FFFFFF',
  width: '56px',
  height: '56px',
  animation: `${pulse} 2s infinite`,
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: '#128C7E',
    transform: 'scale(1.1)',
  },

  '& svg': {
    fontSize: '28px',
  },

  [theme.breakpoints.down('sm')]: {
    bottom: '96px',
    right: '16px',
    width: '50px',
    height: '50px',

    '& svg': {
      fontSize: '24px',
    },
  },
}));

const WHATSAPP_NUMBER = '447888601455';

export default function WhatsAppButton() {
  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Chat with us on WhatsApp" placement="left" arrow>
      <WhatsAppFab
        aria-label="Contact us on WhatsApp"
        onClick={handleClick}
      >
        <WhatsAppIcon />
      </WhatsAppFab>
    </Tooltip>
  );
}
